import { render, staticRenderFns } from "./demandSubmit.vue?vue&type=template&id=11b0b398&scoped=true"
import script from "./demandSubmit.vue?vue&type=script&lang=js"
export * from "./demandSubmit.vue?vue&type=script&lang=js"
import style0 from "./demandSubmit.vue?vue&type=style&index=0&id=11b0b398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0b398",
  null
  
)

export default component.exports